<template>
  <div class="container_content">
    <!-- <nav-title>
      <div slot="title">测风塔信息</div>
    </nav-title> -->
    <div class="content_nav-wrapper">
      <span
        @click="tabChange(0)"
        class="content_nav"
        :class="{ 'content_nav-active': activeIndex == 0 }"
        >基本信息</span
      >
      <span
        @click="tabChange(1)"
        class="content_nav"
        :class="{ 'content_nav-active': activeIndex == 1 }"
        >信息通道</span
      >
    </div>
    <div class="content">
      <basic-info
        v-if="activeIndex == 0"
        :form="basicInfo"
        :if-update="ifUpdate"
        @update="reciData"
      ></basic-info>
      <msg-channel
        v-if="activeIndex == 1"
        :tableData="channelData"
        :channel-type-list="channelTypeList"
        :if-update="ifUpdate"
      ></msg-channel>
    </div>
  </div>
</template>

<script>
import basicInfo from './basic-info';
import msgChannel from './msg-channel';
export default {
  data() {
    return {
      activeIndex: 0,
      basicInfo: {},
      channelData: [],
      channelTypeList: []
    };
  },
  computed: {
    towerId() {
      return this.$store.state.WindData.idString;
    },
    ifUpdate() {
      //是否显示修改和保存按钮
      let towerInfo = this.$store.state.WindData.towerObj;
      let { ifUpdate } = towerInfo || {};
      return ifUpdate;
    }
  },
  watch: {
    towerId(newValue, oldValue) {
      if (newValue && newValue != oldValue) {
        let towerId = newValue.toString().split('-')[0];
        this.getData(towerId);
      }
    }
  },
  methods: {
    async getBasicInfo(towerId) {
      if (!towerId) return;
      let res = await this.$fetch('/winddata/tower/getTower', {
        module: 'windData',
        params: {
          towerId: towerId
        }
      });
      if (res.code == 0) {
        this.basicInfo = res.data && res.data.tower;
      }
    },
    getChannelInfo(towerId) {
      if (!towerId) return;
      this.channelData = [];
      this.$fetch('/winddata/tower/getChannelInfo', {
        module: 'windData',
        showLoading: { mask: true },
        showError: true,
        params: {
          towerId
        }
      })
        .then(res => {
          let data = res.data;
          // this.channelStateList = data.channelStateList;
          this.channelTypeList = data.channelTypeList;
          let channelInfos = data.channelInfo;
          for (let i = 0; i < channelInfos.length; i++) {
            this.channelData.push({ ...channelInfos[i], edit: false });
          }
          if (this.channelData.length > 1) {
            this.channelData.sort(function(a, b) {
              return a.channelNo - b.channelNo;
            });
          }
        })
        .catch(e => {
          console.log({ e });
        });
    },
    tabChange(index) {
      if (this.activeIndex === index) return;
      this.activeIndex = index;
      let towerId = this.towerId.toString().split('-')[0];
      this.getData(towerId);
    },
    getData(towerId) {
      if (this.activeIndex == 0) {
        this.getBasicInfo(towerId);
      } else {
        this.getChannelInfo(towerId);
      }
    },
    reciData(formData) {
      if (formData) {
        for (let key in formData) {
          this.basicInfo[key] = formData[key];
        }
      }
    }
  },
  mounted() {
    let towerId = this.towerId.toString().split('-')[0];
    this.getData(towerId);
  },
  components: {
    basicInfo,
    msgChannel
  }
};
</script>

<style lang="less" scoped>
.content {
  padding: 20px 10px;
  // background: rgb(240,245, 250);
  background: #f1f6fa;
  box-shadow: 1px 3px 5px 0px rgba(4, 0, 0, 0.1);
  border-radius: 10px;
}
</style>
